import colors from "../../../../common/styles/colors";

export const containerStyles = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: colors.lightGrey1,
  width: "100vw",
  padding: 0,
  minHeight: "100vh",
  position: "relative",
  overflow: "hidden",
  ["@media (min-width:1200px)"]: {
    maxWidth: "100vw"
  },
  ["@media (max-width:706px)"]: {
    padding: "0"
  }
};